module.exports = __webpack_public_path__ + "static/media/teacher-placeholder.99990cf0.svg";